import type { TItem, TToastOptions } from "@monta/design-system";

export enum majors {
  math = 60,
  experimental = 61,
  humanities = 62,
  educationalMajor = 0,
}

export const gradesItems: TItem<string>[] = [
  { value: "12", label: "دوازدهم" },
  { value: "11", label: "یازدهم" },
  { value: "10", label: "دهم" },
];
export const fullGradesItems: TItem<string>[] = [
  { value: "4", label: "چهارم" },
  { value: "5", label: "پنجم" },
  { value: "6", label: "ششم" },
  { value: "7", label: "هفتم" },
  { value: "8", label: "هشتم" },
  { value: "9", label: "نهم" },
  { value: "10", label: "دهم" },
  { value: "11", label: "یازدهم" },
  { value: "12", label: "دوازدهم" },
];

export const majorItems: TItem<string>[] = [
  {
    value: majors.math.toString(),
    label: "ریاضی",
  },
  {
    value: majors.experimental.toString(),
    label: "تجربی",
  },
  {
    value: majors.humanities.toString(),
    label: "انسانی",
  },
];

export const errorToastOption: TToastOptions = {
  message: "خطایی رخ داده",
  timeout: 4000,
  position: "bottom-right",
};

export const successToastOption: TToastOptions = {
  message: "عملیات با موفقیت انجام شد",
  timeout: 4000,
  position: "bottom-right",
};
export enum OtpTypesEnum {
  SIGN_UP = "SIGN_UP",
  LOGIN = "LOGIN",
  FORGOT_PASSWORD = "FORGOT_PASSWORD",
  SUBMIT_PHONE_NUMBER = "SUBMIT_PHONE_NUMBER",
}
